export default __webpack_public_path__ + "static/media/gg2.80db8d77.jpeg";